import axios from 'axios';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Gallery from "./Gallery";
import Testimonials from "./Testimonials";
import Contact from "./Contact";
import Services from './Services.js';
import About from './About';
import NotFound from './NotFound';
import { useEffect, useState } from 'react';

function App() {
  const [message, setMessage] = useState('');

  useEffect(() => {
    axios.get('/api/message')
      .then(res => setMessage(res.data.message))
      .catch(err => console.log(err));
  }, []);

  return (
       <>
         <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
    </>

  );
}

export default App;



